/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createSplitGetResponseFromDiscriminatorValue, serializeSplitPatchRequest, type SplitGetResponse, type SplitPatchRequest } from '../../../../models';
// @ts-ignore
import { CalculationRequestBuilderRequestsMetadata, type CalculationRequestBuilder } from './calculation';
// @ts-ignore
import { ScheduledtransactionsRequestBuilderRequestsMetadata, type ScheduledtransactionsRequestBuilder } from './scheduledtransactions';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/splits/{splitId}
 */
export interface WithSplitItemRequestBuilder extends BaseRequestBuilder<WithSplitItemRequestBuilder> {
    /**
     * The calculation property
     */
    get calculation(): CalculationRequestBuilder;
    /**
     * The scheduledtransactions property
     */
    get scheduledtransactions(): ScheduledtransactionsRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SplitGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SplitGetResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     patch(body: SplitPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(body: SplitPatchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithSplitItemRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/splits/{splitId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithSplitItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithSplitItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    calculation: {
        requestsMetadata: CalculationRequestBuilderRequestsMetadata,
    },
    scheduledtransactions: {
        requestsMetadata: ScheduledtransactionsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithSplitItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithSplitItemRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithSplitItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        adapterMethodName: "send",
        responseBodyFactory:  createSplitGetResponseFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: WithSplitItemRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSplitPatchRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
